import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PASSPORT_APP_ISSUER_PATHS } from '../constants/passportNav';

/** Requires Firebase session; issuer org is verified on /issuer/home or /issuer/profile. */
export default function IssuerProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="passport-loading">Loading…</div>;
  }
  if (!user) {
    return <Navigate to={PASSPORT_APP_ISSUER_PATHS.LOGIN} state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
